/* unplugin-vue-components disabled */import script from "./NewsKeyWord.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewsKeyWord.vue?vue&type=script&lang=ts&setup=true"

import "./NewsKeyWord.vue?vue&type=style&index=0&id=c2ae7be6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2ae7be6"]])

export default __exports__